import React from "react"
import Label from "@kit/design/label"
import Input from "@kit/design/input"
import { ColorInput } from "@kit/design/color-picker"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "../../components/padding"
import { Margin } from "app/regions/blocks/section/utils/margin"
import { ColumnRatio } from "../../components/column-ratio"
import { BlocksImageUploader } from "app/regions/blocks/shared/blocks-image-uploader"
import { Expander } from "app/regions/blocks/shared/expander"
import { BackgroundColor } from "../../components/background-color"
import { BorderSettings } from "../../components/border-settings"
import PixelSlider from "@kit/design/pixel-slider"
import { VerticalAlign } from "../../components/vertical-align"
import { FontSettings } from "../../../header/utils/font-settings"
import { useSavedColors } from "hooks/use-saved-colors"

export function PersonalSignatureSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()

  return (
    <>
      <div className="mb-4">
        <ColumnRatio
          properties={properties}
          update={update}
          label="Image width"
          min={3}
          max={50}
          step={1}
        />
      </div>
      <div className="mb-4">
        <VerticalAlign properties={properties} update={update} />
      </div>

      <Expander label="Image">
        <div>
          <BlocksImageUploader
            className="h-40"
            label="Image"
            name="image"
            image={properties.image}
            alt={properties.alt}
            update={file =>
              update({
                image: file.image || properties.image,
                alt: file.alt
              })
            }
            remove={() => update({ image: "", alt: "" })}
          />
        </div>

        <div>
          <PixelSlider
            label="Image radius"
            name="imageRadius"
            value={properties.imageRadius}
            onChange={value => update({ imageRadius: value })}
            min={0}
            max={50}
          />
        </div>

        <div>
          <Label htmlFor="imageUrl">Image URL</Label>
          <Input
            className="text-gray-700 mb-1 w-full"
            placeholder="https://example.com"
            name="imageUrl"
            onChange={e => update({ imageUrl: e.target.value })}
            value={properties.imageUrl || ""}
          />
        </div>
      </Expander>

      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />

        <div>
          <Label htmlFor="headingColor">Name</Label>
          <ColorInput
            id="headingColor"
            name="headingColor"
            onChange={color => update({ headingColor: color.hex })}
            value={properties.headingColor}
            savedColors={savedColors}
          />
        </div>

        <div>
          <Label htmlFor="textColor">Subtitle</Label>
          <ColorInput
            id="textColor"
            name="textColor"
            onChange={color => update({ textColor: color.hex })}
            value={properties.textColor}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <Expander label="Spacing">
        <div className="mb-4">
          <Padding properties={properties} update={update} />
        </div>

        <div className="mb-4">
          <Margin properties={properties} update={update} />
        </div>
      </Expander>

      <Expander label="Fonts">
        <FontSettings
          label="Name font"
          fontFamilySetting="headingFontFamily"
          fontWeightSetting="headingFontWeight"
          properties={properties}
          update={update}
        />

        <FontSettings
          label="Subtitle font"
          fontFamilySetting="textFontFamily"
          fontWeightSetting="textFontWeight"
          properties={properties}
          update={update}
        />
      </Expander>

      <BorderSettings properties={properties} update={update} />
    </>
  )
}
